import React from 'react';
import ReactDOM from 'react-dom';

import TabbedContent from './app';

Array.from(document.querySelectorAll('.directrelief__tabbed-content'))
  .forEach((element) => {
    ReactDOM.render(
      <TabbedContent
        tabs={JSON.parse(element.dataset.tabs)}
      />,
      element,
    );
  });
